import { useMobileBreakpoint } from "@ob/theme";
import { Box, Link, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useIntl } from "react-intl";
import * as documents from "./constants";

export type FooterProps = {
  onLogoClick?: () => void;
};

export const Footer: FC<FooterProps> = ({ onLogoClick }) => {
  const t = useIntl();
  const { isMobile } = useMobileBreakpoint();
  return (
    <Stack
      className="hfooter"
      component="footer"
      flex={0}
      sx={({ palette }) => ({
        backgroundColor: isMobile
          ? palette.footer.backgroundColor.mobile
          : palette.footer.backgroundColor.desktop,
      })}
      minHeight={160}
      justifyContent="center"
      alignItems="center"
      px={5}
      py={6}
      mt={6}
      width="100%"
    >
      <Box maxWidth={600}>
        <Typography variant="small" display="block" mb={4}>
          <Link
            variant="small"
            href={documents.LINK_PRIVACY_POLICY}
            download
            style={{ whiteSpace: "nowrap" }}
          >
            {t.formatMessage({ id: "footer.privacyPolicy" })}
          </Link>
          {" / "}
          <Link
            variant="small"
            href={documents.LINK_COOKIE_POLICY}
            target="_blank"
            style={{ whiteSpace: "nowrap" }}
          >
            {t.formatMessage({ id: "footer.cookiePolicy" })}
          </Link>
          {" / "}
          <Link
            variant="small"
            href={documents.LINK_INFORMATION_SHEET}
            download
            style={{ whiteSpace: "nowrap" }}
          >
            {t.formatMessage({ id: "footer.informationSheet" })}
          </Link>
        </Typography>
        <Typography
          variant="xsmall"
          sx={theme => ({
            fontWeight: 400,
            color: theme.palette.footer.color.desktop,
            lineHeight: "16px",
          })}
          dangerouslySetInnerHTML={{
            __html: t.formatMessage({
              id: isMobile
                ? "footer.copyrightMobile"
                : "footer.copyrightDesktop",
            }),
          }}
        />
      </Box>
    </Stack>
  );
};
